import { render, staticRenderFns } from "./LabeledButton.vue?vue&type=template&id=0043446c&scoped=true"
import script from "./LabeledButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./LabeledButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LabeledButton.vue?vue&type=style&index=0&id=0043446c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0043446c",
  null
  
)

export default component.exports